// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"f09f4e73","475":"d716ce60","700":"c037ec71","958":"21fadffa"}[chunkId] + ".chunk.js";
};